import { useState, useEffect, useContext } from "react";
import BackofficeIcon from "../ions/BackofficeIcon";

import { FaHome, FaHandshake, FaFileContract, FaHandHoldingUsd, FaUsers, FaMoneyBill, FaCogs, FaAddressBook } from "react-icons/fa"
import { BiCog } from "react-icons/bi"
import { PiPlantBold } from "react-icons/pi"
import { HiDocumentText } from "react-icons/hi"

import UserImage from "../atoms/UserImage";
import SectionSidebar from "../molecules/SectionSidebar";
import { AuthContext } from "../../services/Auth/AuthContext";
import NewTooltip from "../atoms/NewTooltip";
import { RiMailSendFill } from "react-icons/ri";
import { VscSymbolStructure } from "react-icons/vsc";
import { Link } from "react-router-dom";
import appConfig from "../../config/app-config";

export const BATCH_ANALYSIS_LIST = "/analysis/batch-analysis";

const BACKOFFICE_URL = appConfig.apis.backofficeApiUrl;

const Sidebar = () => {
	const [isSidebarOpen, setSidebarOpen] = useState(false);
	const [currentSidebarTab, setCurrentSidebarTab] = useState(null);
	const [isAdmin, setIsAdmin] = useState(false);
	const { user } = useContext(AuthContext);

	useEffect(() => {
		if (user)
			setIsAdmin(user.roles.includes("ADMIN"));

		const watchScreen = () => {
			if (window.innerWidth <= 1024) {
				setSidebarOpen(false);
			}
		};

		window.addEventListener("resize", watchScreen);

		return () => {
			window.removeEventListener("resize", watchScreen);
		};
	}, [user]);

	const toggleSidebar = (tab: any) => {
		if (isSidebarOpen && currentSidebarTab === tab) {
			setSidebarOpen(false);
		} else {
			setSidebarOpen(true);
			setCurrentSidebarTab(tab);
		}
	};

	const toggleUserMenu = () => {
		if (isSidebarOpen) setSidebarOpen(false);
		else {
			toggleSidebar("tabUser");
		}
	};

	// Função para fechar sidebar quando um item for selecionado
	const handleItemClick = () => {
		setSidebarOpen(false);
		setCurrentSidebarTab(null);
	};

	const partnerFeatureFlag = () => {
		return {
			href: '/person/partners/0/100/id/DESC',
			label: 'Parceiras',
			itemKey: "menu-partners-all",
		};
	};

	const isProd = appConfig.isProd;

	const sidebarBg = isProd ? 'bg-slate-100' : 'bg-teal-600 dark:bg-teal-700';
	const overlayBg = isProd ? 'bg-slate-100' : 'bg-teal-600 dark:bg-teal-700';
	const defaultButtonClasses = isProd ? 'text-gray-500 bg-white' : 'text-white bg-teal-600';
	const activeButtonClasses = isProd ? 'text-white bg-blue-800' : 'text-white bg-teal-800';
	const iconColor = isProd ? '' : 'text-white';

	const FF_INDIVIDUAL_LIST_ACCESSIBLE = true; // Habilitado em todos os ambientes

	return (
		<aside className="sidebar flex flex-shrink-0 transition-all h-screen">
			{isSidebarOpen && (
				<div
					onClick={() => setSidebarOpen(false)}
					className="fixed inset-0 z-10 bg-black bg-opacity-50 lg:hidden"
				></div>
			)}
			{isSidebarOpen && (
				<div className={`fixed inset-y-0 z-10 w-16 ${overlayBg}`}></div>
			)}

			<nav
				aria-label="Options"
				className={`z-20 flex-col items-center flex-shrink-0 hidden w-16 py-4 border-r-2 shadow-md sm:flex border-black-100 ${sidebarBg}`}
			>
				<BackofficeIcon />

				<div className="flex flex-col items-center flex-1 p-2 space-y-4">

					<Link
						to={"home"}
						onClick={handleItemClick}
						className={`p-2 transition-colors rounded-lg shadow-md hover:bg-blue-400 hover:text-white focus:outline-none focus:ring focus:ring-primary focus:ring-offset-white focus:ring-offset-2 ${defaultButtonClasses}`}
					>
						{FaHome && <FaHome className={`w-5 h-5 ${iconColor}`} />}
					</Link>

					<NewTooltip content="Cadastro" alignment="right">
						<button
							id="cadastro-menu-button"
							onClick={() => toggleSidebar("tabCadastro")}
							className={`p-2 transition-colors rounded-lg shadow-md hover:bg-blue-400 hover:text-white focus:outline-none focus:ring focus:ring-primary focus:ring-offset-white focus:ring-offset-2 ${isSidebarOpen && currentSidebarTab === "tabCadastro" ? activeButtonClasses : defaultButtonClasses}`}
						>
							{FaAddressBook && <FaAddressBook className={`w-5 h-5 ${iconColor}`} />}
						</button>
					</NewTooltip>

					<a href={`${BACKOFFICE_URL}/croptypes/all`}
						className={`p-2 transition-colors rounded-lg shadow-md hover:bg-blue-400 hover:text-white focus:outline-none focus:ring focus:ring-primary focus:ring-offset-white focus:ring-offset-2 ${defaultButtonClasses}`}
					>
						{PiPlantBold && <PiPlantBold className={`w-5 h-5 ${iconColor}`} />}
					</a>

					<NewTooltip content="Jurídico" alignment="right">
						<button
							id="legal-menu-button"
							onClick={() => toggleSidebar("tabLegal")}
							className={`p-2 transition-colors rounded-lg shadow-md hover:bg-blue-400 hover:text-white focus:outline-none focus:ring focus:ring-primary focus:ring-offset-white focus:ring-offset-2 ${isSidebarOpen && currentSidebarTab === "tabLegal" ? activeButtonClasses : defaultButtonClasses}`}
						>
							{FaFileContract && <FaFileContract className={`w-5 h-5 ${iconColor}`} />}
						</button>
					</NewTooltip>

					<NewTooltip content="Fila de pedidos" alignment="right">
						<button
							id="referral-menu-button"
							onClick={() => toggleSidebar("tabReferrals")}
							className={`p-2 transition-colors rounded-lg shadow-md hover:bg-blue-400 hover:text-white focus:outline-none focus:ring focus:ring-primary focus:ring-offset-white focus:ring-offset-2 ${isSidebarOpen && currentSidebarTab === "tabReferrals" ? activeButtonClasses : defaultButtonClasses}`}
						>
							{FaHandHoldingUsd && <FaHandHoldingUsd className={`w-5 h-5 ${iconColor}`} />}
						</button>
					</NewTooltip>

					<NewTooltip content="Empréstimos" alignment="right">
						<button
							id="loan-menu-button"
							onClick={() => toggleSidebar("tabLoan")}
							className={`p-2 transition-colors rounded-lg shadow-md hover:bg-blue-400 hover:text-white focus:outline-none focus:ring focus:ring-primary focus:ring-offset-white focus:ring-offset-2 ${isSidebarOpen && currentSidebarTab === "tabLoan" ? activeButtonClasses : defaultButtonClasses}`}
						>
							{FaHandshake && <FaHandshake className={`w-5 h-5 ${iconColor}`} />}
						</button>
					</NewTooltip>

					<NewTooltip content="Motor de Crédito" alignment="right">
						<button
							id="motor-de-credito-menu-button"
							onClick={() => toggleSidebar("tabMotorCredito")}
							className={`p-2 transition-colors rounded-lg shadow-md hover:bg-blue-400 hover:text-white focus:outline-none focus:ring focus:ring-primary focus:ring-offset-white focus:ring-offset-2 ${isSidebarOpen && currentSidebarTab === "tabMotorCredito" ? activeButtonClasses : defaultButtonClasses}`}
						>
							{FaCogs && <FaCogs className={`w-5 h-5 ${iconColor}`} />}
						</button>
					</NewTooltip>

					<NewTooltip content="Financeiro" alignment="right">
						<button
							id="financial-menu-button"
							onClick={() => toggleSidebar("tabFinancial")}
							className={`p-2 transition-colors rounded-lg shadow-md hover:bg-blue-400 hover:text-white focus:outline-none focus:ring focus:ring-primary focus:ring-offset-white focus:ring-offset-2 ${isSidebarOpen && currentSidebarTab === "tabFinancial" ? activeButtonClasses : defaultButtonClasses}`}
						>
							{FaMoneyBill && <FaMoneyBill className={`w-5 h-5 ${iconColor}`} />}
						</button>
					</NewTooltip>

					<NewTooltip content="Comercial" alignment="right">
						<button
							id="comercial-menu-button"
							onClick={() => toggleSidebar("tabCommercial")}
							className={`p-2 transition-colors rounded-lg shadow-md hover:bg-blue-400 hover:text-white focus:outline-none focus:ring focus:ring-primary focus:ring-offset-white focus:ring-offset-2 ${isSidebarOpen && currentSidebarTab === "tabCommercial" ? activeButtonClasses : defaultButtonClasses}`}
						>
							{FaUsers && <FaUsers className={`w-5 h-5 ${iconColor}`} />}
						</button>
					</NewTooltip>

					{/* TODO ocultar quando nao tiver permissao */}
					<NewTooltip content="Comunicação" alignment="right">
						<button
							id="communication-menu-button"
							onClick={() => toggleSidebar("tabCommunication")}
							className={`p-2 transition-colors rounded-lg shadow-md hover:bg-blue-400 hover:text-white focus:outline-none focus:ring focus:ring-primary focus:ring-offset-white focus:ring-offset-2 ${isSidebarOpen && currentSidebarTab === "tabCommunication" ? activeButtonClasses : defaultButtonClasses}`}
						>
							{RiMailSendFill && <RiMailSendFill className={`w-5 h-5 ${iconColor}`} />}
						</button>
					</NewTooltip>


					<NewTooltip content="Contratos" alignment="right">
						<button
							id="contracts-menu-button"
							onClick={() => toggleSidebar("tabContracts")}
							className={`p-2 transition-colors rounded-lg shadow-md hover:bg-blue-400 hover:text-white focus:outline-none focus:ring focus:ring-primary focus:ring-offset-white focus:ring-offset-2 ${isSidebarOpen && currentSidebarTab === "tabContracts" ? activeButtonClasses : defaultButtonClasses}`}
						>
							{HiDocumentText && <HiDocumentText className={`w-5 h-5 ${iconColor}`} />}
						</button>
					</NewTooltip>

					<NewTooltip content="Estruturação" alignment="right">
						<button
							id="structuring-menu-button"
							onClick={() => toggleSidebar("tabStructuring")}
							className={`p-2 transition-colors rounded-lg shadow-md hover:bg-blue-400 hover:text-white focus:outline-none focus:ring focus:ring-primary focus:ring-offset-white focus:ring-offset-2 ${isSidebarOpen && currentSidebarTab === "tabStructuring" ? activeButtonClasses : defaultButtonClasses}`}
						>
							{VscSymbolStructure && <VscSymbolStructure className={`w-5 h-5 ${iconColor}`} />}
						</button>
					</NewTooltip>
				</div>

				<div className="flex flex-col items-center flex-1 p-2 space-y-4 flex-col-reverse">
					{isAdmin ?
						<NewTooltip content="Configurações gerais" alignment="right">
							<button
								data-tooltip-target="tooltip-generic"
								onClick={() => toggleSidebar("tabGeneric")}
								className={`p-2 transition-colors rounded-lg shadow-md hover:bg-blue-400 hover:text-white focus:outline-none focus:ring focus:ring-primary focus:ring-offset-white focus:ring-offset-2 ${isSidebarOpen && currentSidebarTab === "tabGeneric" ? activeButtonClasses : defaultButtonClasses}`}
							>
								{BiCog && <BiCog className={`w-5 h-5 ${iconColor}`} />}
							</button>
						</NewTooltip>
						: null}
				</div>

				<UserImage
					imageUrl="/no-user-image.jpeg"
					label="No User Image"
					onIconClick={toggleUserMenu}
				/>
			</nav>

			<div
				className={`${isSidebarOpen ? 'fixed inset-y-0 left-0 z-10 flex-shrink-0 w-[260px] bg-white dark:bg-gray-900 transform translate-x-0' : 'hidden transform -translate-x-full'
					} border-r-2 shadow-lg sm:left-16 border-primary-100 sm:w-64 lg:static lg:w-[260px] transition-transform duration-300 ease-in-out`}
			>
				<SectionSidebar
					sectionMenuItems={[
						{
							title: "Pessoa Física",
							menuItems: [
								{ href: '/loan-order/farmer-list/0/100/loanorder.id/DESC', label: 'Listagem de produtores' },
								{ href: '/individual/individual-list/0/100/id/DESC', label: 'PFs', visible: FF_INDIVIDUAL_LIST_ACCESSIBLE },
							],
						},
						{
							title: "Pessoa Jurídica",
							menuItems: [
								{ href: `${BACKOFFICE_URL}/guarantor/all`, label: 'Parceiras Solidárias', external: true },
								partnerFeatureFlag(),
								{ href: `${BACKOFFICE_URL}/partner/new`, label: 'Cadastrar revenda', external: true },
								{ href: `${BACKOFFICE_URL}/partnerUsers/all`, label: 'Usuários das revendas', external: true },
								{ href: '/person/signatories', label: 'Signatários' },
							],
						}]}
					onCloseMenu={handleItemClick}
					tabName="tabCadastro"
					currentSidebarTab={currentSidebarTab}
				/>

				<SectionSidebar
					onCloseMenu={handleItemClick}
					sectionMenuItems={[
						{
							title: "Fila de pedidos",
							menuItems: [
								{ href: `${BACKOFFICE_URL}/referral/analysis/all?sort=createdAt,DESC`, label: 'Análise', external: true },
								{ href: `${BATCH_ANALYSIS_LIST}/0/40/createdAt/DESC`, label: 'Subir pedidos em lote' },
								{ href: `${BACKOFFICE_URL}/referrals/register`, label: 'Registrar solicitações por CPF', external: true },
								{ href: 'referrals/list-unlinked-order/0/100/referral.id/ASC', label: 'Pedidos não vinculados' },
								{ href: 'referrals/loan-order-analysis/rejected/0/100/referral.id/ASC', label: 'Cancelados/reprovados' },
							],
						},
						{
							title: "Pré-análise",
							menuItems:
								[
									{ href: '/referrals/partner-analysis/0/100/referral.id/ASC', label: 'Lista de Pedidos - Revenda' },
									{ href: '/referrals/partner-analyzed/0/100/referral.id/ASC', label: 'Pedidos Analisados - Revenda' },
									{ href: '/referrals/reasons/0/20/description/ASC/d=;t=PRE_ANALYSIS;', label: 'Motivos da pré-análise' },
								],
						},
						{
							title: "Pedido de empréstimo",
							menuItems:
								[
									{ href: '/referrals/farmer-analysis/0/100/referral.id/ASC', label: 'Lista de Pedidos - Produtor' },

									{ href: '/referrals/loan-order-analysis/0/100/referral.id/ASC', label: 'Operações aprovadas' },

									{ href: '/referrals/reasons/0/20/description/ASC/d=;t=LOAN_ORDER;', label: 'Motivos' },
								],
						},
					]}
					tabName="tabReferrals"
					currentSidebarTab={currentSidebarTab}
					showConfigMenu={true}
					urlConfigMenu="/referrals/configuration"
				/>

				<SectionSidebar
					onCloseMenu={handleItemClick}
					sectionMenuItems={[
						{
							title: "Empréstimos",
							menuItems: [
								{ href: `${BACKOFFICE_URL}/loans/management`, label: 'Acompanhamento dos contratos', external: true },
								{ href: `${BACKOFFICE_URL}/loans/all`, label: 'Lista de empréstimos', external: true },
								{ href: `${BACKOFFICE_URL}/loans/partial-payment`, label: 'Lista de adiantamentos parciais', external: true },
							],
						},
					]}
					tabName="tabLoan"
					currentSidebarTab={currentSidebarTab}
				/>

				<SectionSidebar
					onCloseMenu={handleItemClick}
					sectionMenuItems={[
						{
							title: "Motor de crédito",
							menuItems: [
								{ href: '/blocklist/0/40/createdAt/DESC', label: 'Blocklist' },
								{ href: '/credit-analysis/processamentos', label: 'Análise de Crédito' },
							],
						},
						{
							title: "Provedores de dados",
							menuItems: [
								{ href: '/data-provider/batch-report/0/100/createdAt/DESC', label: 'Relatórios em lote' },
								{ href: '/data-provider/report-type/0/20/id/ASC/d=;', label: 'Tipos de Relatório' },
								{ href: '/data-provider/annual-provider-reports/0/20/year/DESC', label: 'Relatórios anuais' },
							],
						},
						{
							title: "Motor de Recomendação",
							menuItems: [
								{ href: '/recommendation-engine/recommendations/0/20/createdAt/DESC', label: 'Recomendações' },
								{ href: '/recommendation-engine/parecer-view', label: 'Parecer PLD' },
								{ href: '/recommendation-engine/rules/0/20/name/ASC', label: 'Regras' },
							],
						},
						{
							title: "Análises Sicor",
							menuItems: [
								{ href: '/sicor/report/0/20/document/DESC', label: 'Consultar relatórios' },
							],
						},
					]}
					tabName="tabMotorCredito"
					currentSidebarTab={currentSidebarTab}
				/>

				<SectionSidebar
					onCloseMenu={handleItemClick}
					sectionMenuItems={[
						{
							title: "Financeiro",
							menuItems: [

								{ href: '/financial/disbursement-list', label: 'Dimensa CPRs Varejo' },
								{ href: '/financial/liquidations-list', label: 'Dimensa Liquidações/Baixas' },
								{ href: '/financial/dimensa-lote-list', label: 'Dimensa Consulta de lotes' },
								{ href: '/settlement/title-debts', label: 'Títulos de Dívida' },
							],
						},
					]}
					tabName="tabFinancial"
					currentSidebarTab={currentSidebarTab}
				/>

				<SectionSidebar
					onCloseMenu={handleItemClick}
					sectionMenuItems={[
						{
							title: "Comercial",
							menuItems: [
								{ href: '/commercial/0/100/partner.id/ASC', label: 'Associação Parceira x Gerentes' },
							],
						},
					]}
					tabName="tabCommercial"
					currentSidebarTab={currentSidebarTab}
				/>

				<SectionSidebar
					onCloseMenu={handleItemClick}
					sectionMenuItems={[
						{
							title: "Comunicação",
							menuItems: [
								{ href: '/communication/calendar/0/0/0', label: 'Calendário de agendamentos' },
								{ href: '/communication/notifications', label: 'Notificações' },
								{ href: '/communication/contact/0/20/updatedAt/DESC/s=;st=;', label: 'Contatos' },
							],
						},
						{
							title: "Modelos",
							menuItems: [
								{ href: '/communication/templates/0/20/id/ASC', label: 'Listagem' },
								{ href: '/communication/template-slack/form', label: 'Slack' },
								{ href: '/communication/template-mail/form', label: 'Email' },
							],
						},
					]}
					tabName="tabCommunication"
					currentSidebarTab={currentSidebarTab}
					showConfigMenu={true}
					urlConfigMenu="/communication/configuration"
				/>

				<SectionSidebar
					onCloseMenu={handleItemClick}
					sectionMenuItems={[
						{
							title: "Usuários",
							menuItems: [
								{ href: '/users', label: 'Lista de usuários' },
							],
						},
					]}
					tabName="tabUsers"
					currentSidebarTab={currentSidebarTab}
				/>

				<SectionSidebar
					onCloseMenu={handleItemClick}
					sectionMenuItems={[
						{
							title: 'Estruturação',
							menuItems: [
								{ href: '/structuring/operation', label: 'Nova operação' },
								{ href: '/structuring/operations/0/20', label: 'Operações' }
							],
						},
						{
							title: 'Garantias',
							menuItems: [
								{ href: '/collateral/guarantees', label: 'Análise de garantias' },
								{ href: '/collateral/validation', label: 'Validação de sacados' }
							],
						},
					]}
					tabName="tabStructuring"
					currentSidebarTab={currentSidebarTab}
				/>

				<SectionSidebar
					onCloseMenu={() => setSidebarOpen(false)}
					sectionMenuItems={[
						{
							title: "Contratos",
							menuItems: [
								{ href: '/contracts/0/100/id/ASC/s=;', label: 'Lista de Contratos' },
							],
						},
					]}
					tabName="tabContracts"
					currentSidebarTab={currentSidebarTab}
				/>

				<SectionSidebar
					onCloseMenu={() => setSidebarOpen(false)}
					sectionMenuItems={[
						{
							title: "Jurídico",
							menuItems: [
								{ href: `${BACKOFFICE_URL}/contract-templates/all`, label: 'Modelos de contrato', external: true },
								{ href: '/legal/files/0/200/process/ASC/', label: 'Catálogo de arquivos' },
								{ href: '/legal/credit-operations/0/200/contract_number/ASC/', label: 'Operações de crédito' },
								{ href: '/signature', label: 'Assinaturas digitais' },
							],
						},
					]}
					tabName="tabLegal"
					currentSidebarTab={currentSidebarTab}
				/>

				<SectionSidebar
					onCloseMenu={() => setSidebarOpen(false)}
					sectionMenuItems={[
						{
							title: "Geo-Localização",
							menuItems: [
								{ href: '/cities', label: 'Cidades' },
								{ href: '/provinces', label: 'Estados' },
							],
						},
						{
							title: "Configurações",
							menuItems: [
								{ href: '/feature-flags/referral/0/20/id/ASC', label: 'Features flags - Referral' },
							],
						},
						{
							title: "Ativos de TI",
							menuItems: [
								{ href: '/ti/software-portfolio/0/200/name/ASC/', label: 'Catálogo de projetos' },
								{ href: '/ti/software-analysis', label: 'Análise de engenharia' },
							],
						},
					]}
					tabName="tabGeneric"
					currentSidebarTab={currentSidebarTab}
				/>

				<SectionSidebar
					onCloseMenu={handleItemClick}
					sectionMenuItems={[
						{
							title: "Usuário",
							menuItems: [
								{ href: '/change-password', label: 'Alterar senha' },
								// { href: '/change-image', label: 'Alterar imagem' },
								// { href: '/change-layout', label: 'Alterar layout' },
							],
						},
					]}
					tabName="tabUser"
					currentSidebarTab={currentSidebarTab}
				/>

			</div>
		</aside>
	);
};

export default Sidebar;
